
define('modules/application/responseLibrary',[

"app",

// Libs
"backbone"],

function(app, Backbone) {
  var responseLibrary = Backbone.Model.extend({
    defaults : {
      packagesByIdWizardChoice : [],
      packagesByIdPackageClass : [],
      products                 : []
    },

    getDatas : function(repository, idWizardChoice, accessoryLineId) {
      var contentToReturn = repository[idWizardChoice+"-"+accessoryLineId] ? repository[idWizardChoice+"-"+accessoryLineId] : false;

      return contentToReturn ? JSON.parse(contentToReturn) : contentToReturn;
    },

    setDatas : function(repository, idWizardChoice, accessoryLineId, content) {
      contentToReturn = repository[idWizardChoice+"-"+accessoryLineId] = JSON.stringify(content);
    },

    getPackagesByIdWizardChoice : function(idWizardChoice, accessoryLineId) {
      return this.getDatas(this.get("packagesByIdWizardChoice"), idWizardChoice, accessoryLineId);
    },

    setPackagesByIdWizardChoice : function(idWizardChoice, accessoryLineId, content) {
      this.setDatas(this.get("packagesByIdWizardChoice"), idWizardChoice, accessoryLineId, content);
    },

    getPackagesByPackageClassId : function(idPackageClass, accessoryLineId) {
      return this.getDatas(this.get("packageByPackageClassId"), idPackageClass, accessoryLineId);
    },

    setPackagesByPackageClassId : function(idPackageClass, accessoryLineId, content) {
      this.setDatas(this.get("packageByPackageClassId"), idPackageClass, accessoryLineId, content);
    },

    getProducts : function(packageClassId, accessoryLineId) {
      return this.getDatas(this.get("products"), packageClassId, accessoryLineId);
    },

    setProducts : function(packageClassId, accessoryLineId, content) {
      this.setDatas(this.get("products"), packageClassId, accessoryLineId, content);
    }


  });

  return responseLibrary;
});